export const EVENTS = {
    PAGE_VIEW                                           : 'page_view',
    EVENT_RENEWAL_QUOTE_PAGE_DEFAULT_PLAN_SELECTION     : 'renewal_quote_page_default_plan_selection',
    EVENT_RENEWAL_QUOTE_PAGE_RECOMMENDED_PLAN_SELECTION : 'renewal_quote_page_recommended_plan_selection',
    EVENT_RENEWAL_QUOTE_PAGE_UPSELL_POP_UP_SUCCESS      : 'renewal_quote_page_upsell_pop_up_success',
    EVENT_RENEWAL_QUOTE_PAGE_UPSELL_POP_UP_FAIL         : 'renewal_quote_page_upsell_pop_up_fail',
    EVENT_RENEWAL_QUOTE_PAGE_UPSELL_PLAN_SELECTION      : 'renewal_quote_page_upsell_plan_selection',
    EVENT_RENEWAL_QUOTE_PAGE_RENEW_NOW                  : 'renewal_quote_page_renew_now',
    EVENT_RENEWAL_PROPOSAL_PAGE_REVIEW_AND_PAY          : 'renewal_proposal_page_review_and_pay',
    EVENT_RENEWAL_PROPOSAL_PAGE_PAYMENT_STATUS          : 'renewal_proposal_page_payment_status',
    EVENT_RENEWAL_PROPOSAL_PAGE_POLICY_ISSUANCE         : 'renewal_proposal_page_policy_issuance',
    EVENT_RENEWAL_PROPOSAL_PAGE_PHONE_NUMBER_CHANGE     : 'renewal_proposal_page_phone_number_change',
    EVENT_RENEWAL_PROPOSAL_PAGE_EMAIL_ID_CHANGE         : 'renewal_proposal_page_email_id_change',
    EVENT_RENEWAL_ERROR                                 : 'renewal_health_error',
    EVENT_BUTTON_CLICK                                  : 'Button-click-event'
  };
  